var Operator = window.Operator || {};
Operator.blockEditors = Operator.blockEditors || {};

$.extend(Operator.blockEditors, {
    MapPortsBrickModel: function (opts) {
        var editor = opts.editor
            , block = opts.block
            , blockElementId = block.attr('id')
            , schemeBlockId = block.attr('schemeBlockId')
            , form = editor.find('form');

        Operator.Layout.setupCollections(form);
        
        form.on('submit', function (e) {
            var newSpecNames = {};
            _.forEach(_.values(Operator.Layout._friendlyPortSpecNames), function(key){
                newSpecNames[key] = [];
            });
            
            _.forEach(form.find('.port-mapping'), function (e) {
                var $e = $(e);

                newSpecNames[Operator.ConnectionManager.targetPortType].push($e.find('[name$="InputPortName"]').val());
                newSpecNames[Operator.ConnectionManager.sourcePortType].push($e.find('[name$="OutputPortName"]').val());
            });
            
            //A single input port should be allowed to write to multiple output ports
            newSpecNames[Operator.ConnectionManager.targetPortType] = _.uniq(newSpecNames[Operator.ConnectionManager.targetPortType]);
            
            var result = Operator.Layout.connectionManager.updateEndpointsFromSpecs(blockElementId, newSpecNames);
            if (!result.isValid){
                e.preventDefault();
                e.stopPropagation();
                e.stopImmediatePropagation();

                alert(result.errors.join('\n'));
            } 
            
        });
    }
});